import React from 'react'

import { Flex, Stack, Text, Link } from '@chakra-ui/layout'
import { Avatar } from '@chakra-ui/avatar'
import { IconButton } from '@chakra-ui/button'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { Image } from '@chakra-ui/image'
import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/menu'

import { Link as ReactRouterLink } from 'react-router-dom'

import { FiMenu, FiLogOut, FiSettings, FiBook } from 'react-icons/fi'

import { SidebarDrawerContext } from '../../context/SidebarDrawerContext'
import { useAuth } from '../../hooks/useAuth'

import { Sound } from '../../pages/Booking/Sound'

import { CustomerTypeEnum } from '../../schemas/enum.schemas'

type HeaderProps = {
  title: string
}

export function Header({ title }: HeaderProps) {
  const { onOpen } = React.useContext(SidebarDrawerContext)
  const { user, signOut } = useAuth()

  return (
    <Flex
      as="header"
      align="center"
      width="full"
      height="5.1875rem"
      marginX="auto"
      paddingX="1.5rem"
      background="white"
    >
      {user?.customer.type === CustomerTypeEnum.enum.PARKING && <Sound />}
      <Stack direction="row" spacing="2rem">
        <IconButton
          aria-label="Menu"
          size="sm"
          display={{ base: 'inline-flex', notebook: 'none' }}
          onClick={onOpen}
          icon={<FiMenu />}
          variant="outline"
          colorScheme="orange"
        />

        <Text fontSize="2xl" fontWeight="bold">
          {title}
        </Text>
      </Stack>

      <Flex align="center" marginLeft="auto">
        <Avatar
          display={{ base: 'none', notebook: 'flex' }}
          marginRight="0.8125rem"
          size="sm"
          opacity={user?.parking.picture ? '1' : '0.6'}
          src={
            user?.parking.picture ||
            'https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/avatar.svg'
          }
        />
        <Text
          display={{ base: 'none', notebook: 'flex' }}
          fontSize="sm"
          fontWeight="bold"
        >
          {user?.parking.name ?? user?.customer.name}
        </Text>
        {user?.customer.type === CustomerTypeEnum.enum.PARKING &&
          user?.parking.premium && (
            <Image
              src="https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/crown.svg"
              width="1rem"
              height="1rem"
              marginLeft={{
                base: '0',
                notebook: '0.5rem',
              }}
            />
          )}
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Menu"
            icon={<ChevronDownIcon />}
            variant=""
            _focus={{
              borderColor: 'none',
            }}
          />
          <MenuList>
            {user?.customer.type === CustomerTypeEnum.enum.PARKING &&
              !user?.parking.premium && (
                <MenuItem
                  icon={
                    <Image src="https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/crown.svg" />
                  }
                  as={Link}
                  isExternal
                  href="https://parkoff.com.br/estacionamento"
                  background="parkoff.teal.400"
                  textColor="white"
                  borderRadius="md"
                  _hover={{
                    background: 'parkoff.teal.400',
                  }}
                  _focus={{
                    background: 'parkoff.teal.400',
                  }}
                >
                  Seja um Estacionamento VIP
                </MenuItem>
              )}
            <MenuItem
              icon={<FiBook />}
              as={Link}
              isExternal
              href="https://parkoff.com.br/blog"
            >
              ParkOff Blog
            </MenuItem>
            <MenuItem
              as={ReactRouterLink}
              to={
                user?.customer.type === CustomerTypeEnum.enum.ADMIN
                  ? '/configuration-admin'
                  : `/configuration/${user?.parking.id}`
              }
              icon={<FiSettings />}
            >
              Configurações
            </MenuItem>
            <MenuItem icon={<FiLogOut />} onClick={() => signOut()}>
              Sair
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  )
}
